function getHeaders() {
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
    }

    return new Headers(headers)
}

function handleInvalidResponse(r) {
    console.log(r)
    if (r.status == 302 || r.status == 301) {

        window.location.href = r.url
        return r
    } else if (!r.ok) {
        throw Error("Die Anfrage konnte nicht bearbeitet werden, versuchen Sie es später noch einmal.")
    }

    return r
}

function convertToJson(response) {
    try {
        if (response.redirected)
            return undefined
        const json = response.json()
        console.log(json);
        return json;
    }
    catch(e)
    {
        throw Error("Es ist ein technisches Problem aufgetreten, versuchen Sie es später noch einmal.")
    }
}

export function apiUrl(path) {
    return process.env.API_HOST + path;
}

export function loadOrderStatus(code, signature) {
    return fetch(
            apiUrl('/shop/purchaseOrder/' + code + "/" + signature + "/status"),
            { headers: getHeaders() }
        )
        .then(handleInvalidResponse)
        .then(convertToJson)
}


export function shopData() {
    return fetch(
            apiUrl('/shop/training'),
            {
              headers: getHeaders(),
              cache: "no-cache"
            }
        )
        .then(handleInvalidResponse)
        .then(convertToJson)
}

export function checkVoucherStatus(total, code) {
    const body = {
        voucher_code: code,
        total: total
    }
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    };
    return fetch(
        apiUrl('/shop/voucher/status/'),
        {
            headers: { 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify(body),
        }
    ).then(response => response.json())
}

export function payOrder(order, code, signature) {
    const body = {
        ...order.paymentOption
    }

    return fetch(
            apiUrl('/shop/purchaseOrder/' + code + "/" + signature + "/pay"),
            {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(body),
            }
        )
        .then(handleInvalidResponse)
        .then(convertToJson)
}

export function loadOffersRange() {
    return fetch(
        apiUrl('/shop/offers/range'),
        {
            headers: getHeaders(),
            cache: "no-cache"
        }
    )
    .then(handleInvalidResponse)
    .then(convertToJson)
}

function createBookingBody(order, discount) {
    return {
        type: 'booking',
        discount: {
            ref_id: order.discount.ref_id,
            type: order.discount.type,
            voucher_code: order.discount.voucher_code,
            voucher_amount: order.discount.voucher_amount,
            voucher_valide: order.discount.voucher_valide
        },
        invoiceInfo: {
            firstName: order.invoiceInfo.firstName,
            lastName: order.invoiceInfo.lastName,
            city: order.invoiceInfo.city,
            street: order.invoiceInfo.street,
            zipCode: order.invoiceInfo.zipCode,
            email: order.invoiceInfo.email,
            phone: order.invoiceInfo.phone
        },
        booking: {
            participants: order.participants,
            trainingId: order.trainingId
        },
        contactInfo: {
            email: order.invoiceInfo.email,
            phone: order.invoiceInfo.phone
        },
        payment: {
            ...order.paymentOption
        }
    }
}

function createVoucherBody(order, discount) {
    return {
        type: 'voucher',
        discount: {
            ref_id: order.discount.ref_id,
            type: order.discount.type,
            voucher_code: order.discount.voucher_code,
            voucher_amount: order.discount.voucher_amount,
            voucher_valide: order.discount.voucher_valide
        },
        voucher: {
            amount: order.voucherAmount,
            type: 'amount',
            name: order.voucherName,
            text: order.voucherText
        },
        invoiceInfo: {
            firstName: order.invoiceInfo.firstName,
            lastName: order.invoiceInfo.lastName,
            city: order.invoiceInfo.city,
            street: order.invoiceInfo.street,
            zipCode: order.invoiceInfo.zipCode,
            email: order.invoiceInfo.email,
            phone: order.invoiceInfo.phone
        },
        contactInfo: {
            email: order.invoiceInfo.email,
            phone: order.invoiceInfo.phone
        },
        payment: {
            ...order.paymentOption
        }
    }
}

export function submitOrder(order) {
    console.log(order)
    const orderType = order.type == "voucher" ? "voucher" : "booking";
    let body = null;
    if (order.type == "voucher") {
        body = createVoucherBody(order);
    } else {
        body = createBookingBody(order);
    }

    return fetch(
            apiUrl('/shop/purchaseOrder/place'),
            {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(body),
            }
        )
        .then(handleInvalidResponse)
        .then(convertToJson)


}



// WEBPACK FOOTER //
// ./src/api.js